export const messages = [
  "When life gives you lemons, lick them.",
  "We've already said what we didn't mean to say, and now we've said too much.",
  "Life is like the ocean — too many octopuses, not enough submarines.",
  "The corn don't know it's on the cob, but that don't change the way the cornbread tastes.",
  "Human determination overcomes all willpower.",
  "Not all roses smell the same.",
  "No one can make us care, but that doesn't stop us from believing that we can.",
  "'Good morning' is just the 'good night' of last night's 'good night'.",
  "The path to success is only trod by those who succeed in knowing the way."
];

